import {IComponentOptions, ILogService} from "angular";
import {IModalInstanceService} from "angular-ui-bootstrap";
import {Application} from "../../../model/Application";
import {LoadingService} from "../../../loading/loading.service";
import {ApplicationService} from "../../application.service";

class ApplicationReopenModalController {

    public modalInstance: IModalInstanceService;
    public resolve: any;
    public close: any;
    public dismiss: any;
    public application: Application;
    public comments: string;
    public isEmailSent: boolean;

    /* @ngInject */
    constructor(private $log: ILogService,
                private toaster: any,
                private loadingService: LoadingService,
                private applicationService: ApplicationService) {
    }

    public $onInit() {
        this.application = this.resolve.application;
        this.isEmailSent = true;
    }

    public submit() {
        this.$log.info("submit()");
        this.loadingService.show();

        this.applicationService.reopenStudentCreditApplication(this.application, this.comments, this.isEmailSent)
            .then((updatedAssessment) => {
                this.$log.debug("updatedAssessment", updatedAssessment);
                let toasterMsg = "Student application re-opened ";
                if(this.isEmailSent) toasterMsg += "and email sent";
                this.toaster.pop({type: "success", title: toasterMsg});
                this.close({$value: updatedAssessment});
            })
            .catch((reason) => {
                this.$log.debug("Failed to invite", reason);
                this.toaster.pop({type: "failure", title: "Failed to reopen application"});
            })
            .finally(() => {
                this.loadingService.hide();
            });
    }

    public cancel() {
        this.dismiss({$value: "cancel"});
    }
}

export const ApplicationReopenModalComponent: IComponentOptions = {
    bindings: {
        modalInstance: "<",
        resolve: "<",
        close: "&",
        dismiss: "&"
    },
    controller: ApplicationReopenModalController,
    template: require("./application-reopen-modal.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/application/modals/reopen-modal/application-reopen-modal.component.ts